import React from 'react';
import { GraduationCap, Sparkles } from 'lucide-react';

const HeroSection = () => {
  return (
    <div className="text-center mb-12">
      {/* <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-600 rounded-full text-sm font-semibold mb-6">
        <Sparkles size={16} />
        <span>Fall 2025 Policy</span>
      </div> */}
      
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 dark:text-white mb-4">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-400 dark:to-purple-400">CUCalc</span>
      </h1>
      
      <p className="text-lg md:text-xl text-slate-600 dark:text-slate-400 max-w-2xl mx-auto mb-8 leading-relaxed">
        Calculate your GPA with confidence using our tool designed for COMSATS University Islamabad students.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-500 dark:text-slate-400">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-emerald-500" />
          <span>Accurate</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-blue-500" />
          <span>All Campuses</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-purple-500" />
          <span>Free Forever</span>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
